export const APPLIED_PROMOTION_INFORMATION_MODAL =
  'applied-promotion-information-modal'
